import MaterialTable, {MTableBody, MTableToolbar} from 'material-table'
import React, { useEffect, useMemo, useState, useRef } from 'react'

import { getColumns, getFooter } from './tableHelpers/CostAgrsPlans';
import {
  getCustomFilterAndSearch, localization, modifyDefaultOptions, options, tableIconsModified,
} from '../../../helpers/table';
import { useAPICostAgrsPlan } from '../adminApiService';
import useAPI from '../../../hooks/useAPI';
import useDataReducer from './useDataReducer';
import { mapIdsToLabels } from '../../../helpers/plansHelper';
import MTableHeader from '../../../components/material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../components/material-table-overrides/MTableFilterRow';
import DownloadLink from '../../../components/common/DownloadLink';
import {Button, Col, Row} from "react-bootstrap";
import PopoverElement from "../../../components/common/PopoverElement";
import ConfirmModal from "../../../components/common/ConfirmModal";
import LoadingTable from '../../../components/table/LoadingTable';

export default function TabCostAgrsPlans(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [isModalInitPlans, setIsModalInitPlans] = useState(false);
    const [data, dispatchData] = useDataReducer();
    const MTableFiltersRef = useRef({});

    const api = useAPI();
    const [getData, saveData, removeData] = useMemo(() => useAPICostAgrsPlan(api), [api]);

    const updateData = async () => {
        const result = await getData('?report=true');
        if (props.plansDictionary)
            dispatchData(() => result.map(el => ({
                ...mapIdsToLabels(props.plansDictionary, el),
                ...el
            })));
    };

    useEffect(async () => {
      await updateData();
      setIsLoading(false);
    }, [props.plansDictionary])

    const handleSaveData = async (entry) => {
        const resp = await saveData({
            ...entry,
            year: parseInt(entry.year),
        });
        if (!resp || resp.error) return null;
        return {...resp, ...mapIdsToLabels(props.plansDictionary, resp)};
    }

    const handleRemoveData = async (entry) => {
        const resp = await removeData(entry);
        if (!resp || resp.error) return null;
        return resp;
    }

    const initPlans = async () => {
        setIsLoading(true);
        const post = await api.post('/mng/cost/agrs/0/plans/0/init', {year: new Date().getFullYear()});
        if (!post.error) {
            await updateData();
        } else setIsLoading(false);
        setIsModalInitPlans(false);
    };

    return (
        <>
            {/* <LoadingTable loadingObject={{isLoading}}> */}
            <MaterialTable
                title={<div className="d-flex align-items-center">
                    <h3 style={{marginBottom: 0}}>Планы по статьям затрат соглашения</h3>
                </div>}
                columns={getColumns({...props, MTableFiltersRef})}
                options={modifyDefaultOptions({
                    // actionsColumnIndex: -1,
                    addRowPosition: 'first',
                    maxBodyHeight: 'calc(100vh - 442px)',
                    headerStyle: { height: 95, zIndex: 0 },
                    filterCellStyle: {
                        position: "sticky",
                        top: 95,
                        background: 'white',
                        zIndex: 5
                    },
                    search: false
                })}
                editable={{
                    onRowAdd: (newData) =>
                        new Promise(async (resolve, reject) => {
                            const resp = await handleSaveData(newData);
                            if (resp)
                                await dispatchData(prev => [resp, ...prev]);
                            resolve();
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise(async (resolve, reject) => {
                            const resp = await handleSaveData(newData);
                            if (resp)
                                await dispatchData(prev => prev.map(d => d.id === resp.id ? resp : d));
                            resolve();
                        }),
                    onRowDelete: oldData =>
                        new Promise(async (resolve, reject) => {
                            const resp = await handleRemoveData(oldData);
                            if (resp)
                                await dispatchData(prev => prev.filter(v => v.id !== oldData.id));
                            resolve();
                        }),
                }}
                components={{
                    Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}/>),
                    FilterRow: (props) => (<MTableFilterRow {...props} />),
                    Body: (props) => (
                        <LoadingTable spinnerStyle={{marginTop: '40px'}} loadingObject={{isLoading}}>
                            <MTableBody {...props}/>
                            {getFooter(props.renderData)}
                        </LoadingTable>
                    ),
                    Toolbar: props => (
                        <>
                            <MTableToolbar {...props} />
                            <Row>
                                <Col md={12} className="d-flex justify-content-end align-items-center">
                                    <DownloadLink
                                        variant="outline-primary"
                                        url={`/mng/cost/agrs/0/plans/export`}
                                        filename={`Планы по статьям затрат соглашения.xlsx`}
                                        style={{marginLeft: 16}}
                                        className="me-2"
                                    >Excel
                                    </DownloadLink>
                                    <Button className="me-2" variant="outline-warning"
                                            onClick={() => setIsModalInitPlans(true)}>
                                        {/* Создать планы на {new Date().getFullYear()} */}
                                        Сгенерировать строки в таблице на {new Date().getFullYear()}
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    ),
                }}
                icons={tableIconsModified}
                localization={localization}
                data={data.entries}
            />
          {/* </LoadingTable> */}
            <ConfirmModal
                show={isModalInitPlans}
                onConfirm={initPlans}
                onClose={() => setIsModalInitPlans(false)}
                loading={isLoading}
                message={`В таблице будут сгенерированы строки (планы) по статьям затрат Соглашения в соответствии с заведенными планами по Соглашениям на ${new Date().getFullYear()}. Отменить действие будет невозможно. Осуществить действие?`}
                headerText={`Создание планов на ${new Date().getFullYear()}`}
            />
        </>
    )
}

const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
